import { useEffect } from 'react';
import Form from '@components/dynamic-form/Form';
import { useNonPcn, useRequest } from '@stores';
import { useQuery } from '@tanstack/react-query';
import { LOOKUP_QUERY_KEYS } from '@src/api/services/lookup';
import { LookupQueries } from '@src/api/services/lookup/query';
import Loader from '@components/loader/Loader';
import { RequestType } from '@src/utils/enums';
import { getNonPcnFormConfig } from './nonPcnData';

export const nonPcnInformationMetadata = {
  sectionName: `${RequestType.NonPreconstructionNotification} Information`,
};

const NonPcnInformation = ({ group, stepNo, componentId, formVersion }) => {
  const { isFormReadOnly: isReadOnly, updateSection, isSectionValid, getSections } = useRequest();
  const { setNonPcnRequest } = useNonPcn();
  const { nonPcnForm, initNonPcnData } = getNonPcnFormConfig(formVersion);

  const { data: opts, isLoading } = useQuery({
    queryKey: [LOOKUP_QUERY_KEYS.GET_NWP_GP_PERMIT_TYPES],
    queryFn: () => LookupQueries.getNwpGpPermitTypes(),
  });

  useEffect(() => {
    opts && initNonPcnData(opts);
  }, [opts, initNonPcnData]);

  const handleOnChange = (data) => {
    updateSection(stepNo, { dirty: true });
    setNonPcnRequest(data);
  };

  const handleOnValidationChange = (isValid) => {
    if (isSectionValid(stepNo) === isValid) {
      return;
    } else {
      updateSection(stepNo, { valid: isReadOnly ? true : isValid });
      if (group) {
        const parentIndex = group?.parentIndex;

        if (!parentIndex) {
          return;
        }
        const currentSections = getSections();
        const isGroupValid = group?.indexes.every((index) => currentSections[index]?.valid);

        updateSection(parentIndex, {
          valid: isReadOnly ? true : isGroupValid,
        });
      }
    }
  };

  if (isLoading || !opts) {
    return <Loader variant='section' />;
  }

  return (
    <Form
      componentId={componentId}
      formData={nonPcnForm}
      isInformation={false}
      isReadOnly={isReadOnly}
      onChange={handleOnChange}
      onValidationChange={handleOnValidationChange}
      stepNo={stepNo}
    />
  );
};

NonPcnInformation.metadata = nonPcnInformationMetadata;

export default NonPcnInformation;
